"use client";

import ReviewCard from "./review-card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "./ui/carousel";
import { useTranslations } from "next-intl";
import { useUserStore } from "@/store/store";
import { useLocale } from "next-intl";

const Testimonials = () => {
  const t = useTranslations("testimonials");
  const { role } = useUserStore();
  const locale = useLocale();
  
  // Get the appropriate content based on role, default to trainer if role is not available
  const content = role === "client" ? t.raw("client") : t.raw("trainer");
  const reviews = content?.reviews || [];

  return (
    <section className="py-12 md:py-24 bg-gray-100 ">
      <div className="flex flex-col max-sm:text-center md:flex-row justify-between items-center px-4 md:px-12">
        <h2 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl">
          {t("title")}
        </h2>
        <p className="max-w-lg font-poppins">
          <span className="font-bold">
            {content?.subtitle || t("trainer.subtitle")}
          </span>{" "}
          {content?.description || t("trainer.description")}
        </p>
      </div>
      <div className="relative px-4 md:px-12">
        <Carousel 
          className="pt-24"
          opts={{
            loop: true,
            align: "start",
            slidesToScroll: 1,
          }}
        >
          <CarouselContent className="">
            {reviews.map((review: any, index: number) => (
              <CarouselItem className="basis-full sm:basis-1/2 lg:basis-1/4" key={index}>
                <ReviewCard
                  name={review.name}
                  avatar="/avatar.png"
                  rating={review.rating}
                  review={review.review}
                  date={role === "trainer" ? review.specialty : review.goal}
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="left-2 md:left-4 bg-white hover:bg-gray-50 border-gray-300 hover:border-gray-400 shadow-lg transition-all duration-200" />
          <CarouselNext className="right-2 md:right-4 bg-white hover:bg-gray-50 border-gray-300 hover:border-gray-400 shadow-lg transition-all duration-200" />
        </Carousel>
      </div>
    </section>
  );
};

export default Testimonials;
